"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    // create everything with initial defaults
    function State() {
        // state defaults
        // transport type
        this.type = null;
        // transport subType
        this.subType = null;
        // transport none option
        this.noneOptions = { none: true };
        // list of transportation 
        this.transportation = [];
        this.type = null;
        this.subType = null;
        this.noneOptions = {
            none: true
        };
        this.transportation = [];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=transport_state.js.map